import { render, staticRenderFns } from "./GymSectorSeparator.vue?vue&type=template&id=48534002"
import script from "./GymSectorSeparator.vue?vue&type=script&lang=js"
export * from "./GymSectorSeparator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports